export default __webpack_public_path__ + "static/media/Gida of the Sundered Skies.c08c5f92.jpg";